// Valuesの対外確定表記（About / Careers で共用する正本）
// 出典: 採用_会社紹介資料 v0.2（2026年10月）の VALUES。
// 各Valueは「見出し」「毎日の問い」「説明」の3点で構成する。
export const values = [
  {
    no: '01',
    jp: '徹底してやり切れ。',
    question: 'これ以上できることはないと、言い切れるのか。',
    desc: '当たり前のことを徹底して実行し、やれることを全てやり切って目標を達成する。',
  },
  {
    no: '02',
    jp: '上司の仕事を喰え。',
    question: '100%を積み重ねて、上司の仕事を先回りしてこなせているか。',
    desc: '言われたことを100%でやり続けて信頼を積んだ上で、一つ上の仕事をこなし、自身の役割をストレッチさせる。',
  },
  {
    no: '03',
    jp: '覚悟を持って任せろ。',
    question: '覚悟を持って、他の人に自分の仕事を任せられているか。',
    desc: 'つまずく箇所を先回りしてサポートし、何かあれば巻き取る覚悟で、組織の成長を促す。',
  },
  {
    no: '04',
    jp: '成長に貪欲になれ。',
    question: '先週の自分から、アップデートされているか。',
    desc: '同じ状態に留まらず、誰よりも濃く学び、新しいことをやって、自分の役割・能力を伸ばし続ける。',
  },
  {
    no: '05',
    jp: 'キャップをかけるな。',
    question: '思考にキャップをかけていないか。',
    desc: '考えることにも、やることにも、自分の力にも、上限を置かず、自己認知の外へ出ていき、非連続な成長を生む。',
  },
];
